import { gql } from 'graphql-request'

export namespace CorporateLeadQueries {
  export function getCorporateLeads() {
    return gql`
      query getCorporateLeads($filter: CorporateLeadFilter) {
        corporateLeads(filter: $filter) {
          id
          createdAt
          firstName
          lastName
          companyName
          email
          phone
          numberOfUnits
        }
      }
    `
  }
}
